<div>
    <app-table-component [data]="activityLogList()" [columns]="tableColumns" [totalRecords]="totalRecords()" [rows]="rows" [first]="first" (pageChange)="onPageChange($event)"
        [showColumnSelector]="false" [showClearFilters]="false" [searchControl]="searchControl" [customFilters]="[dateRangeFilter, hasPositionFilter]" />
</div>

@defer (when locationDialog; prefetch on idle) {
<app-show-location-dialog [lat]="selectedIOT.position?.latitude ?? 0" [lng]="selectedIOT.position?.longitude ?? 0" [zoom]="17" [(visibility)]="locationDialog" />
}
